// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__y+wSr","linkActive":"styles_linkActive__fnqGv","wrapper_renderContent":"styles_wrapper_renderContent__RQmlO","renderContent":"styles_renderContent__zWpFQ"};